import React from "react";
import { Helmet } from "react-helmet";
import "./TonkMultiplayerLanding.css";

const androidUrl =
  "https://play.google.com/store/apps/details?id=com.oengines.tonkmultiplayer";
const iosUrl = "https://apps.apple.com/us/app/tonk-multiplayer/id1581717205";

const screenshots = [
  "/assets/img/gamePreviewScreenshots/tonkMultiplayer/1.png",
  "/assets/img/gamePreviewScreenshots/tonkMultiplayer/2.png",
  "/assets/img/gamePreviewScreenshots/tonkMultiplayer/3.png",
  "/assets/img/gamePreviewScreenshots/tonkMultiplayer/4.png",
  "/assets/img/gamePreviewScreenshots/tonkMultiplayer/5.png",
  "/assets/img/gamePreviewScreenshots/tonkMultiplayer/6.png",
  "/assets/img/gamePreviewScreenshots/tonkMultiplayer/7.png",
];

const storeFacts = [
  { label: "Game", value: "Tonk Multiplayer" },
  { label: "Developer", value: "OENGINES GAMES" },
  { label: "Category", value: "Card" },
  { label: "Android rating", value: "4.2 star, 196 reviews" },
  { label: "iOS rating", value: "4.3 out of 5, 50 ratings" },
  { label: "Android installs", value: "10K+ downloads" },
  { label: "Age guidance", value: "Teen on Google Play, 13+ on App Store" },
  { label: "Platforms", value: "Android, iPhone, and iPad" },
];

const features = [
  "Real-time multiplayer card tables",
  "Classic Knock and No Knock Tonk modes",
  "Smooth card controls for drawing, discarding, and grouping",
  "Leaderboards, daily bonuses, and social invite options",
];

export default function TonkMultiplayerLanding() {
  return (
    <main className="tonk-page">
      <Helmet>
        <title>Tonk Multiplayer | OENGINES GAMES</title>
        <meta
          name="description"
          content="Download Tonk Multiplayer by OENGINES GAMES for Android, iPhone, and iPad. Adult-audience card game with in-app purchases and no real-money gambling."
        />
      </Helmet>

      <section className="tonk-hero">
        <div className="tonk-shell">
          <div className="tonk-disclaimer" aria-label="Important game disclaimers">
            <h2>Disclaimer</h2>
            <p>
              The games are intended for an adult audience. The games do not
              offer "real money gambling" or an opportunity to win real money or
              prizes. Tonk Multiplayer contains ads and offers optional in-app
              purchases.
            </p>
          </div>

          <div className="tonk-hero-grid">
            <div className="tonk-hero-copy">
              <p className="tonk-eyebrow">OENGINES GAMES</p>
              <h1>Tonk Multiplayer</h1>
              <p className="tonk-lede">
                A fast online card game inspired by the Tonk and rummy family,
                built for real-time tables with players around the world.
              </p>

              <div className="tonk-actions" aria-label="Download links">
                <a className="tonk-store-button" href={androidUrl} target="_blank" rel="noreferrer">
                  <span>Get it on</span>
                  <strong>Google Play</strong>
                </a>
                <a className="tonk-store-button tonk-store-button--dark" href={iosUrl} target="_blank" rel="noreferrer">
                  <span>Download on the</span>
                  <strong>App Store</strong>
                </a>
              </div>
            </div>

            <div className="tonk-screen" aria-label="Tonk Multiplayer screenshot preview">
              <img src={screenshots[0]} alt="Tonk Multiplayer game table screenshot" />
            </div>
          </div>
        </div>
      </section>

      <section className="tonk-section">
        <div className="tonk-shell tonk-two-column">
          <div>
            <p className="tonk-section-kicker">About the game</p>
            <h2>Play Classic Tonk Online</h2>
            <p>
              Tonk Multiplayer supports 2-player and 3-player card tables. The
              game focuses on forming valid runs, sets, and low-count hands,
              with Classic Knock and No Knock variations available.
            </p>
          </div>

          <div className="tonk-feature-list">
            {features.map((feature) => (
              <div className="tonk-feature" key={feature}>
                <span aria-hidden="true">OK</span>
                <p>{feature}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tonk-section tonk-section--muted">
        <div className="tonk-shell">
          <div className="tonk-section-heading">
            <p className="tonk-section-kicker">Store listing details</p>
            <h2>Current Public App Details</h2>
          </div>

          <div className="tonk-facts">
            {storeFacts.map((fact) => (
              <div className="tonk-fact" key={fact.label}>
                <span>{fact.label}</span>
                <strong>{fact.value}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tonk-section">
        <div className="tonk-shell">
          <div className="tonk-section-heading">
            <p className="tonk-section-kicker">Screenshots</p>
            <h2>Game Preview</h2>
          </div>

          <div className="tonk-gallery">
            {screenshots.map((screenshot, index) => (
              <img
                key={screenshot}
                src={screenshot}
                alt={`Tonk Multiplayer screenshot ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="tonk-final">
        <div className="tonk-shell">
          <h2>Download Tonk Multiplayer</h2>
          <p>
            Available for Android, iPhone, and iPad. Optional in-app purchases
            are clearly disclosed before download.
          </p>
          <div className="tonk-actions tonk-actions--center">
            <a className="tonk-store-button" href={androidUrl} target="_blank" rel="noreferrer">
              <span>Get it on</span>
              <strong>Google Play</strong>
            </a>
            <a className="tonk-store-button tonk-store-button--dark" href={iosUrl} target="_blank" rel="noreferrer">
              <span>Download on the</span>
              <strong>App Store</strong>
            </a>
          </div>
        </div>
      </section>
    </main>
    
  );
}
